import request from '@/utilsCloud/request'
import port from './port'


// 课程分类(大类)
export function getCateExerciseOne(query) {
  return request({
    url: port.exam + '/exercise/cateExerciseOne',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}



// 
export function getEntpExerciseConfigCurrent(query) {
  return request({
    url: port.exam + '/exerciseConfig/getEntpExerciseConfigCurrent',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 练习验证是否购买
export function exerciseDetailVerification(query) {
  return request({
    url: port.exam + '/exercise/exerciseDetailVerification',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


export function exerciseList(query) {
  return request({
    url: port.exam + '/exercise/exerciseList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


export function getEmployeeCourseOverStatus(query) {
  return request({
    url: port.stat + '/statisticsAnalysis/getEmployeeCourseOverStatus',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

export function getEmployeeExerciseCountByExerciseId(query) {
  return request({
    url: port.exam + '/exercise/getEmployeeExerciseCountByExerciseId',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

export function exerciseCollect(data) {
  return request({
    url: port.exam + '/exercise/exerciseCollect',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}

export function submitPaperExercise(data) {
  return request({
    url: port.exam + '/exercise/submitPaperExercise',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}

export function faceComparison(data) {
  return request({
    url: port.exam + '/exercise/faceComparison',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}

export function cateExerciseTwo(query) {
  return request({
    url: port.exam + '/exercise/cateExerciseTwo',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


export function exerciseDetails(query) {
  return request({
    url: port.exam + '/exercise/exerciseDetails',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 去往考试页面
export function getEntpExamConfigCurrent(query) {
  return request({
    url: port.exam + '/examConfig/getEntpExamConfigCurrent',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

//是否提交练习
export function updateExerciseFlag(data) {
  return request({
    url: port.course + '/home/updateExerciseFlag',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}








// WEBPACK FOOTER //
// ./src/apiCloud/examList.js